import { Form } from '@vivaldis/antd-ui'
import type { EmployeeInput } from '@vivaldis/graphql'
import { ActionBar } from './components/ActionBar'
import { FormContent } from './components/FormContent'
import { FormProvider } from './provider/FormProvider'
import { CountryType } from './types/CountryType'
import { Employee } from './types/Employee'

interface Props {
  employee: Employee
  onSubmit: (employeeInput: EmployeeInput) => Promise<void>
  countries: CountryType[]
}

export const EditEmployeeGeneralInformationForm = ({
  employee,
  onSubmit,
  countries
}: Props) => {
  return (
    <FormProvider employee={employee} onSubmit={onSubmit}>
      <Form
        id="edit-employee-general-information-form"
        name="edit-employee-general-information-form"
        autoComplete="off"
      >
        <FormContent countries={countries} />
        <ActionBar />
      </Form>
    </FormProvider>
  )
}
